import _ from 'lodash';
import { getRecentAuths } from '../../common/filtering';
import { gEnums } from '../../enums/globalEnums';
import { createRefPath_event } from '../../firestoreData/appData/appRefPaths';
import { _currentAppUserCountsCollection, _currentAppUserCountsCollection_xxx } from './AppUserReducer';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps";

const _defaultDays = 7

export const appUserManagementInitialState = (initState) => {
  return { ...initState }
};

export const rts = {
  handleAmmend_auths: 'handleAmmend_auths',
  handleChange_appManagementType: 'handleChange_appManagementType',
  handleChange_profileSearch: 'handleChange_profileSearch',
  handleClose_appUser: 'handleClose_appUser',
  handleGet_currentUsers: 'handleGet_currentUsers',
  handleSearchChange: 'handleSearchChange',
  handleSelect_appUser: 'handleSelect_appUser',
  handleSet_allowModifications: 'handleSet_allowModifications',
  handleSet_auths: 'handleSet_auths',
  handleSet_currentUserCounts: 'handleSet_currentUserCounts',
  handleSet_profileType: 'handleSet_profileType',
  handleSet_appUserProfiles: 'handleSet_appUserProfiles',
  ...grts
}

export const showAppManagementTypes = {
  add: 'add',
  auth: 'auth',
  appUserCount: 'appUserCount',
  getClientProfiles: 'getClientProfiles',
  updateAppUserProfiles: 'updateAppUserProfiles',
  updateClientProfiles: 'updateClientProfiles',
  gcNotifications: 'gcNotifications',
  email: 'email',
  showBulkImageUpload: 'showBulkImageUpload',
}

export const userMenuItems = {
  add: 'add',
  checkAuthorizations: 'checkAuthorizations',
  appUserCount: 'appUserCount',
  getClientProfiles: 'getClientProfiles',
  search: 'search',
  sendGCNotifications: 'sendGCNotifications',
  sendSignInEmails: 'sendSignInEmails',
  updateAppUserProfiles: 'updateAppUserProfiles',
  updateClientProfiles: 'updateClientProfiles',
  showBulkImageUpload: 'showBulkImageUpload',
}

/**
 * 
 * @param {*} state 
 * @param {*} action 
 * @returns 
 * @rts (...rts)
 */
export const appUserManagementReducer = (state, action) => {

  const {
    appProfileData,
    authsList,
    foundAll,
    pathViews,
    selectedItems,
    mergedProfiles,
    database_fns,
    fn_cls,
  } = state

  const { dispatch } = action

  const { handleSet_currentUserCounts, handleSet_allClientProfiles, handleSet_auths, handleStartUpdate } = appUserManagementHandlers(dispatch)

  switch (action.type) {

    case rts.handleAmmend_auths:
      if (authsList && mergedProfiles) {
        const z = ammendAuths({ found: foundAll }, mergedProfiles, action.dayCount)
        return { ...state, ...z }
      }
      return { ...state }

    case rts.handleSet_appUserProfiles:
      return { ...state, mergedProfiles: action.mergedProfiles }

    case rts.handleChange_appManagementType:
      const { item } = action
      let _appManagementType;
      switch (item) {
        case userMenuItems.appUserCount:
          _appManagementType = showAppManagementTypes.appUserCount
          break;
        case userMenuItems.add:
          _appManagementType = showAppManagementTypes.add
          break;
        case userMenuItems.checkAuthorizations:
          // _appMangementType = showAppManagementTypes.auth 
          handleStartUpdate()
          getAuths(fn_cls, pathViews, mergedProfiles, handleSet_auths)
          break;
        case userMenuItems.sendSignInEmails:
          _appManagementType = showAppManagementTypes.email
          break;
        case userMenuItems.getClientProfiles:
          _appManagementType = showAppManagementTypes.getClientProfiles
          break;
        case userMenuItems.updateAppUserProfiles:
          _appManagementType = showAppManagementTypes.updateAppUserProfiles
          break;
        case userMenuItems.updateClientProfiles:
          _appManagementType = showAppManagementTypes.updateClientProfiles
          break;
        case userMenuItems.sendGCNotifications:
          _appManagementType = showAppManagementTypes.gcNotifications
          break;
        case userMenuItems.showBulkImageUpload:
          _appManagementType = showAppManagementTypes.showBulkImageUpload
          break;
        default:
          break;
      }
      return { ...state, appManagementType: _appManagementType }

    case rts.handleSet_auths:
      const { results } = action
      const x = ammendAuths(results, mergedProfiles, _defaultDays)
      return { ...state, updating: false, ...x }

    case rts.handleSearchChange:
      if (action.searchValue) {
        const f = _.filter(selectedItems, function (i) {
          return (action.searchValue && i.lastName && i.lastName.toLowerCase().startsWith(action.searchValue.toLowerCase())) ||
            (action.searchValue && i.firstName && i.firstName.toLowerCase().startsWith(action.searchValue.toLowerCase()));
        });
        return {
          ...state,
          filteredItems: f,
        }
      } else {
        return {
          ...state,
          filteredItems: null,
          selectedItems: selectedItems
        }
      }

    case rts.handleChange_profileSearch:
      if (action.searchValue) {
        const f = _.filter(appProfileData, function (i) {
          return (i.lastName && i.lastName.toLowerCase().startsWith(action.searchValue)) ||
            (i.firstName && i.firstName.toLowerCase().startsWith(action.searchValue));
        });
        return {
          ...state,
          filteredItems: f,
        }
      } else {
        return {
          ...state,
          filteredItems: null,
        }
      }

    case rts.handleSelect_appUser:
      if (action.appUserKey) {
        const appUser = selectedItems && selectedItems[action.appUserKey] ? selectedItems[action.appUserKey] : action.appUser
        return {
          ...state,
          selectedAppUserKey: action.appUserKey,
          selectedAppUser: appUser
        }
      } else {
        return {
          ...state,
          selectedAppUserKey: null,
          selectedAppUser: null,
        }
      }

    case rts.handleClose_appUser:
      return { ...state, selectedAppUserKey: null, selectedAppUser: null, }

    case rts.handleSet_profileType:
      const { appProfileData: apd } = action
      return { ...state, profileType: action.profileType, selectedItems: mergedProfiles, appProfileData: apd }


    case rts.handleGet_currentUsers:

      const cbcau = (data) => {
        if (data) { handleSet_currentUserCounts(data) }
      }

      const cbcXXX = (data) => {
        let _xxx = 0
        _.forEach(data, (value) => {
          _xxx += Object.keys(value).length
        })
        console.log('_xxx', _xxx)
      }

      const _refPathCau = createRefPath_event(pathViews, [_currentAppUserCountsCollection])
      database_fns.get_data({ refPath: _refPathCau, callback: cbcau, opts: { ignoreId: true } })

      const _refPathXXX = createRefPath_event(pathViews, [_currentAppUserCountsCollection_xxx])
      database_fns.get_data({ refPath: _refPathXXX, callback: cbcXXX, opts: { ignoreId: true } })
      return { ...state }

    case rts.handleSet_currentUserCounts:
      let _currentUserCount = 0
      const { currentUserCounts } = action
      if (currentUserCounts) {
        _.forEach(currentUserCounts, (value) => {
          _.forEach(value, (value2) => {
            _currentUserCount += value2
          })
        })
      }
      return { ...state, currentUserCounts, currentUserCount: _currentUserCount }

    case rts.handleSet_allowModifications:
      return { ...state, allowAppUserModification: action.allowModification }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation })

    default:
      return { ...state }
  }
}

export const appUserManagementHandlers = (dispatch) => {
  return {
    handleAmmend_auths: (dayCount) => dispatch({ type: rts.handleAmmend_auths, dispatch, dayCount }),
    handleChange_appManagementType: (item) => dispatch({ type: rts.handleChange_appManagementType, dispatch, item }),
    handleChange_profileSearch: (searchValue) => dispatch({ type: rts.handleChange_profileSearch, dispatch, searchValue }),
    handleClose_appUser: () => dispatch({ type: rts.handleClose_appUser, dispatch }),
    handleGet_currentUsers: () => { dispatch({ type: rts.handleGet_currentUsers, dispatch }) },
    handleSearchChange: (searchValue) => dispatch({ type: rts.handleSearchChange, dispatch, searchValue }),
    handleSelect_appUser: (appUser, appUserKey) => dispatch({ type: rts.handleSelect_appUser, dispatch, appUser, appUserKey }),
    handleSet_allowModifications: (allowModification) => dispatch({ type: rts.handleSet_allowModifications, dispatch, allowModification }),
    handleSet_auths: (results) => dispatch({ type: rts.handleSet_auths, dispatch, results }),
    handleSet_currentUserCounts: (currentUserCounts) => { dispatch({ type: rts.handleSet_currentUserCounts, dispatch, currentUserCounts }) },
    handleSet_profileType: (appProfileData, profileType) => dispatch({ type: rts.handleSet_profileType, dispatch, appProfileData, profileType }),
    handleSet_appUserProfiles: (mergedProfiles) => dispatch({ type: rts.handleSet_appUserProfiles, dispatch, mergedProfiles }),
    ...responseHandlers(dispatch)
  }
}

const getAuths = (fn_cls, pathViews, mergedProfiles, callback) => {
  const limit = 100
  if (mergedProfiles) {
    const _mergedProfiles = _.sortBy(mergedProfiles, 'lastName')
    const chunks = _.chunk(_mergedProfiles, limit);
    fn_cls.getAuthsByChunkEmail(chunks, pathViews, true, callback)
  }
}

const ammendAuths = (results, mergedProfiles, dayCount) => {
  const { found } = results
  if (found && mergedProfiles) {
    const recent = getRecentAuths(found, dayCount)
    _.forEach(mergedProfiles, (_staticAppUser, key) => {
      const { email } = _staticAppUser
      const _found = email ? _.find(found, { email: email.toLowerCase() }) : null
      const _recent = email ? _.find(recent, { email: email.toLowerCase() }) : null
      _staticAppUser.foundType = gEnums.authListTypes.notFound
      if (_found) { _staticAppUser.foundType = gEnums.authListTypes.found }
      if (_recent) { _staticAppUser.foundType = gEnums.authListTypes.recent }
      if (_found || _recent) {
        _staticAppUser.metadata = _found.metadata
      }
    })
    const _mergedProfilesEm = _.map(mergedProfiles, (_staticAppUser, key) => ({
      email: _staticAppUser.email,
      foundType: _staticAppUser.foundType
    }))
    const authsList = _.groupBy(mergedProfiles, 'foundType')
    const authsListEm = _.groupBy(_mergedProfilesEm, 'foundType')
    return { authsList, authsListEm, foundAll: found }
  }
  return {}
}

